import { useState } from 'react';
import { FloorplanDetailsModal } from '@/views';
import {
  useUpdateFloorplanMutation,
  useGetFloorplanDetailsQuery,
  UpdateFloorplanArgs,
} from '@/redux';
import { useTranslation } from 'react-i18next';
import { notify } from '@/components';

const useSubmit = (closeModal: () => any) => {
  const [updateFloorplan] = useUpdateFloorplanMutation();

  return async (values: UpdateFloorplanArgs) => {
    await updateFloorplan(values)
      .unwrap()
      .then(() => {
        notify.success.t('floorplans.details.saved');
        closeModal();
      });
  };
};

export function useEditFloorplanAction() {
  const [id, setId] = useState<string>();
  const { currentData } = useGetFloorplanDetailsQuery(
    { id: id! },
    { skip: !id },
  );

  const { t } = useTranslation();
  const submit = useSubmit(() => setId(undefined));

  return {
    openEdit: (id: string) => setId(id),
    editModal: (
      <>
        {id && currentData && (
          <FloorplanDetailsModal
            title={t('floorplans.details.editTitle')}
            buttonSaveName={t('floorplans.details.editButton')}
            onSubmit={submit}
            value={currentData}
            onClose={() => setId(undefined)}
          />
        )}
      </>
    ),
  };
}
